/**
 * Allow scrolling dragging with the mouse even on desktop.
 * @param {DOM node} containerElement that MUST have the "u-slider" css class (i.e. it can be a "<ul>" that contains "<li>" elements)
 * @returns {Function} the unsubscriber
 */
export const slider = (containerElement: HTMLElement) => {
  let isDown = false;
  let startX: number;
  let scrollLeft: number;
  let timeout: NodeJS.Timeout;

  const onEnd = () => {
    isDown = false;
    containerElement.classList.remove('active');
    clearTimeout(timeout);
  };

  const onStart = (e: MouseEvent | TouchEvent) => {
    e.preventDefault();
    isDown = true;
    timeout = setTimeout(() => {
      containerElement.classList.add('active');
    }, 250);
    startX = (e as MouseEvent).pageX || (e as TouchEvent).touches[0].pageX - containerElement.offsetLeft;
    scrollLeft = containerElement.scrollLeft;
  };

  const onMove = (e: MouseEvent | TouchEvent) => {
    if (!isDown) {
      return;
    }

    e.preventDefault();
    const x = (e as MouseEvent).pageX || (e as TouchEvent).touches[0].pageX - containerElement.offsetLeft;
    const dist = x - startX;
    containerElement.scrollLeft = scrollLeft - dist;
  };

  const subscribe = () => {
    containerElement.addEventListener('mousedown', onStart as any);
    containerElement.addEventListener('mousemove', onMove as any);
    containerElement.addEventListener('mouseleave', onEnd);
    containerElement.addEventListener('mouseup', onEnd);
  };

  const unsubscribe = () => {
    containerElement.removeEventListener('mousedown', onStart as any);
    containerElement.removeEventListener('mousemove', onMove as any);
    containerElement.removeEventListener('mouseleave', onEnd);
    containerElement.removeEventListener('mouseup', onEnd);
  };

  subscribe();
  return unsubscribe;
};
